
export const GET_CHECKLISTS = 'GET_CHECKLISTS';
export const GET_CHECKLISTS_FAIL = 'GET_CHECKLISTS_FAIL';
export const GET_CHECKLISTS_SUCCESS = 'GET_CHECKLISTS_SUCCESS';

export const POST_CHECKLISTS_FORM = 'POST_CHECKLISTS_FORM';
export const POST_CHECKLISTS_FORM_FAIL = 'POST_CHECKLISTS_FORM_FAIL';
export const POST_CHECKLISTS_FORM_SUCCESS = 'POST_CHECKLISTS_FORM_SUCCESS';

export const GET_CHECKLISTS_FORM = 'GET_CHECKLISTS_FORM';
export const GET_COMPLETED_CHECKLISTS = 'GET_COMPLETED_CHECKLISTS';



// WEBPACK FOOTER //
// ./src/types/checklist.js